import { render } from "./HosDial.vue?vue&type=template&id=cdf2b706&scoped=true"
import script from "./HosDial.vue?vue&type=script&lang=js"
export * from "./HosDial.vue?vue&type=script&lang=js"

import "./HosDial.vue?vue&type=style&index=0&id=cdf2b706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf2b706"]])

export default __exports__